import apiClient from '../axios.js';

export const lineWelcomeService = {
  async get() {
    return apiClient.get('/line/welcome');
  },

  async save(lineConfigId, templateIds) {
    return apiClient.put(`/line/welcome/${lineConfigId}`, { templateIds });
  }
};
